import { downloadBlob } from "presentation/mobile/utils/download-blob.util";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { useRef, useState } from "react";
import { Document, Page } from "react-pdf";

interface MobilePDFViewerProps {
    url: string;
    fileName?: string
}

const MobilePDFViewer = ({url, fileName}: MobilePDFViewerProps) => {

    const [numPages, setNumPages] = useState<number>();
    const [pageNumber, setPageNumber] = useState<number>(1);

    const menuRef = useRef<Menu>(null);

    const getFileName = (): string => {
        if(!fileName || fileName === ""){
            const dateStr = new Date().toLocaleDateString("pt-PT", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                });
            const withDashes = dateStr.replaceAll("/", "-");

            return `${withDashes}.pdf`
        }

        if(fileName.includes(".pdf"))
            return fileName;
        return `${fileName}.pdf`
    }

    const menuItems = [
        {
            label: 'Transferir',
            icon: 'pi pi-download',
            command: () =>  downloadBlob(url, getFileName())
        }
    ]
    
    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    }

    const getDocumentNavigationButtons = () => {
        if(!numPages || numPages === 1)
            return null;
        
        return (
            <div className="w-full flex justify-content-end">
                <div className="flex w-full align-items-center justify-content-between">
                    <span>{`${pageNumber}/${numPages}`}</span>
                    <div className="flex flex-nowrap gap-2">
                        {
                            pageNumber > 1 && (
                            <div>
                                <Button 
                                    label="Página Anterior "
                                    icon="pi pi-arrow-left"
                                    severity="secondary"
                                    className="px-0 py-0"
                                    text
                                    size="small"
                                    onClick={() => {
                                        setPageNumber(pageNumber - 1)
                                    }}
                                />
                            </div>
                        )
                        }
                        {
                        
                            <Button 
                                label="Próxima Página"
                                icon="pi pi-arrow-right"
                                iconPos="right"
                                className="px-0 py-0"
                                severity="secondary"
                                text
                                disabled={pageNumber >= numPages}
                                size="small"
                                onClick={() => {
                                    setPageNumber(pageNumber + 1)
                                }}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className="flex flex-column justify-content-center align-items-center flex-grow-1">
            <div className="w-full flex justify-content-end">
                <div 
                    className=" align-items-center cursor-pointer"
                    onClick={(event) =>{ menuRef.current?.toggle(event)}}>
                    <i className="pi pi-ellipsis-h text-sm" />
                </div>
            </div>
            <Document file={url} onLoadSuccess={onDocumentLoadSuccess}>
              <Page width={window.innerWidth - 20} pageNumber={pageNumber} />
            </Document>
            {getDocumentNavigationButtons()}
            <Menu model={menuItems} ref={menuRef} id="popup_menu" popup/>
        </div>
    )
}

export default MobilePDFViewer;